module.exports = __webpack_public_path__ + "img/MDI-history.b9c99c27.svg";